import { Text, Avatar, ModalProps } from '@hhgtech/hhg-components/mantine'
import { useIntl } from 'react-intl'

import { useCurrentUrl } from 'hooks/useCurrentUrl'
import { useRouterExtend } from 'hooks/useRouterExtend'

import { StyledModal } from './index.styled'
import { CopyInput } from '../copyInput'
import { SocialItem } from '../types'
import { getSocialListByLocale } from '../utils'

export type ShareModalProps = {
  shareUrl?: string
} & ModalProps

export const Modal = ({ shareUrl: shareUrlProp, ...rest }: ShareModalProps) => {
  const { locale } = useRouterExtend()
  const { formatMessage: f } = useIntl()
  const currentUrl = useCurrentUrl()
  const shareUrl = shareUrlProp || currentUrl
  const socialList = getSocialListByLocale(locale, shareUrl, undefined)

  return (
    <StyledModal
      centered
      withCloseButton={false}
      closeOnClickOutside={true}
      {...rest}
    >
      <div
        style={{
          padding: '1em',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
        className="share-socials"
      >
        <Text size="s3">
          {f({
            id: 'authorPage.share.share',
          })}
        </Text>
        <div style={{ display: 'flex', gap: '0.7em' }}>
          {socialList.map((social: SocialItem, index: number) => (
            <a
              key={index}
              target="_blank"
              href={social.href}
              data-event-category="Social Share"
              data-event-action={social.name}
              data-event-label={currentUrl}
              className="share-icon pointer-event-child-none"
            >
              <Avatar size={32} radius="sm">
                {social.icon}
              </Avatar>
            </a>
          ))}
        </div>
      </div>
      <CopyInput shareUrl={shareUrl} styles={{ root: { padding: '1em' } }} />
    </StyledModal>
  )
}
